import { Icons } from '@Assets/SvgIcons';
import { InfoClock } from '@Assets/SvgIcons/InfoClock';
import TemplateLibrary from '@components/Templates/TemplateLibrary/TemplateLibrary.component';
import { UserHelper } from '@Helper/Infra';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import { getUserInfo, postUserInfo } from '@Store/feature/directory';
import { useAppDispatch, useAppSelector } from '@Store/hooks';
import React from 'react';
import { useParams } from 'react-router-dom';

type MergefloInfoProps = {
  open: boolean;
  handleClose: (close: boolean) => void;
};

export default function MergefloInfo(props: MergefloInfoProps) {
  const { open, handleClose } = props;
  const [videoOpen, setVideoOpen] = React.useState(false);
  const [createTemplate, setCreateTemplate] = React.useState(false);
  let { id } = useParams();
  const userHelper = new UserHelper();
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(getUserInfo);
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    borderRadius: '16px',
    p: 4,
  };
  const skipInfo = () => {
    localStorage.setItem(userInfo?.username + 'infoSkip', 'true');
    handleClose(false);
  };

  const notInterestInfo = () => {
    const userSettingRequest = {
      playbookId: id ?? '',
      type: 'infoSkip',
      settings: {
        infoSkip: true,
      },
    };

    userHelper.updatePlaybookSettings(userSettingRequest as any).then(res => {
      dispatch(postUserInfo(res));
    });
    handleClose(false);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-focus-visible">
          <div
            id="modal-modal-title"
            style={{
              color: '#4C43AA',
              fontSize: 20,
              fontWeight: 600,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <span> Welcome {userInfo?.name + ' ' + userInfo?.surname}</span>
            <div
              style={{
                color: '#46426E',
                fontSize: 14,
                fontWeight: 600,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                marginBottom: 35,
              }}
              onClick={skipInfo}
            >
              <span>SKIP</span>
            </div>
          </div>

          <div>
            <div
              style={{
                color: '#383463',
                fontSize: 16,
                fontWeight: 600,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 35,
              }}
            >
              Mergeflo is a purpose-built tool designed to help you run your
              integration in a collaborative and efficient way.
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div id="left-info" style={{ width: '46%' }}>
                <div
                  id="left-element"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div
                    id="element-icon"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Icons.InfoClock />
                  </div>
                  <div
                    id="element-text"
                    style={{
                      color: '#383463',
                      fontSize: 14,
                      fontWeight: 500,
                      marginLeft: 10,
                    }}
                  >
                    Save time gaining context of how the integration is going
                    with your own{' '}
                    <span
                      style={{
                        fontWeight: 'bold',
                      }}
                    >
                      Customized Dashboard.
                    </span>
                  </div>
                </div>

                <div style={{ height: 20 }}></div>
                <div
                  id="left-element"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div
                    id="element-icon"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Icons.InfoPerson />
                  </div>
                  <div
                    id="element-text"
                    style={{
                      color: '#383463',
                      fontSize: 14,
                      fontWeight: 500,
                      marginLeft: 10,
                    }}
                  >
                    Invite your teammates in their respective{' '}
                    <span
                      style={{
                        fontWeight: 'bold',
                      }}
                    >
                      workstreams such as HR, Legal, Finance
                    </span>{' '}
                    etc.
                  </div>
                </div>

                <div style={{ height: 20 }}></div>
                <div
                  id="left-element"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div
                    id="element-icon"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Icons.InfoRid />
                  </div>
                  <div
                    id="element-text"
                    style={{
                      color: '#383463',
                      fontSize: 14,
                      fontWeight: 500,
                      marginLeft: 10,
                    }}
                  >
                    Gain visibility on{' '}
                    <span
                      style={{
                        fontWeight: 'bold',
                      }}
                    >
                      Issues, Risks, Decisions, and Dependencies
                    </span>{' '}
                    to understand blockers of the integration.
                  </div>
                </div>
                <div style={{ height: 20 }}></div>
                <div
                  id="left-element"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div
                    id="element-icon"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Icons.InfoFile />
                  </div>
                  <div
                    id="element-text"
                    style={{
                      color: '#383463',
                      fontSize: 14,
                      fontWeight: 500,
                      marginLeft: 10,
                    }}
                  >
                    Want some templates to jump start your integration planning?{' '}
                    <span
                      style={{
                        fontWeight: 'bold',
                        color: '#383463',
                      }}
                    >
                      Check out our templates.
                    </span>
                  </div>
                </div>
              </div>
              <div
                id="right-info"
                style={{
                  width: '52%',
                  cursor: 'pointer',
                }}
              >
                <div onClick={() => setVideoOpen(true)}>
                  <Icons.VideoPreview />
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              justifyItems: 'center',
              marginTop: 15,
            }}
          >
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <TemplateLibrary
              fromWelcome={true}
              preActions={() => {
                setCreateTemplate(true);
              }}
              afterActions={() => {
                const userSettingRequest = {
                  playbookId: id ?? '',
                  type: 'infoSkip',
                  settings: {
                    infoSkip: true,
                  },
                };

                userHelper
                  .updatePlaybookSettings(userSettingRequest as any)
                  .then(res => {
                    dispatch(postUserInfo(res));
                  });
              }}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyItems: 'center',
                background: '#5D54C0',
                borderRadius: 8,
                color: 'white',
                padding: '8px 15px',
                fontSize: '13px',
                cursor: 'pointer',
                marginLeft: 15,
              }}
              onClick={notInterestInfo}
            >
              Understood, don’t show again
            </div>
          </div>
        </Box>
      </Modal>
      <Modal open={videoOpen} onClose={() => setVideoOpen(false)}>
        <div style={{ width: '95%', height: '80%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div></div>
            <IconButton
              style={{
                width: 24,
                height: 24,
                background: 'white',
                marginBottom: 8,
              }}
              size="small"
              onClick={() => setVideoOpen(false)}
            >
              <Icons.Cancel />
            </IconButton>
          </div>
          <iframe
            title="title"
            src="https://www.youtube.com/embed/_sTPSCGn7k4"
            width={'100%'}
            height={'95%'}
          ></iframe>
        </div>
      </Modal>
    </>
  );
}
